let serviceList = [
  {
    title: "Wheel Knuckle",
    des: "",
    img: "assets/img/service/product14.png",
  },
  {
    title: "Upper Arm",
    des: "",
    img: "assets/img/service/product15.png",
  },
  {
    title: "Cylinder Eye",
    des: "",
    img: "assets/img/service/product16.png",
  },
  {
    title: "Shock Mount",
    des: "",
    img: "assets/img/service/product17.png",
  },
  {
    title: "Eye Let",
    des: "",
    img: "assets/img/service/product18.png",
  },
  {
    title: "T Joint",
    des: "",
    img: "assets/img/service/product19.png",
  },
  {
    title: "Wheel Hub Forgings",
    des: "",
    img: "assets/img/service/product20.png",
  },
  {
    title: "Hydraulic Pump Cover",
    des: "",
    img: "assets/img/service/product21.png",
  },
  {
    title: "Cuplers",
    des: "",
    img: "assets/img/service/product1.jpg",
  },
  {
    title: "Industrial Elbow",
    des: "",
    img: "assets/img/service/product2.jpg",
    link: "/products/industrial-elbow",
  },
  {
    title: "Industrial Tee",
    des: "",
    img: "assets/img/service/product3.jpg",
    link: "/products/industrial-tee",
  },
  {
    title: "Flange Coupling",
    des: "",
    img: "assets/img/service/product4.jpg",
  },
  {
    title: "PTO Flange",
    des: "",
    img: "assets/img/service/product5.jpg",
  },
  {
    title: "Cylinder Holding Bottom",
    des: "",
    img: "assets/img/service/product6.jpg",
  },
  {
    title: "3 Way Connector",
    des: "",
    img: "assets/img/service/product7.jpg",
  },
  {
    title: "Forged Flange",
    des: "",
    img: "assets/img/service/product8.jpg",
  },
  {
    title: "Universal Joint Cross",
    des: "",
    img: "assets/img/service/product9.png",
  },
  {
    title: "Connecting Yoke",
    des: "",
    img: "assets/img/service/product11.jpg",
  },
  {
    title: "Gear",
    des: "",
    img: "assets/img/service/product12.jpg",
  },
  {
    title: "Hydraulic cylinder Bottom",
    des: "",
    img: "assets/img/service/product22.jpg",
  }
];

export default serviceList;
